import { faCheck } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ProtectionPlan_ApplicationFragment } from 'rental/generated.graphql';
import { ProtectionPlanTerms } from './ProtectionPlan';


interface Props {
  application: ProtectionPlan_ApplicationFragment
  portalSlug: string
}

export const ProtectionPlanBenifits = (props: Props) => (
  <div>
    <Benifit>Coverage against fire, theft, and accidental damage.</Benifit>
    <Benifit>Peace of mind for your valuable products.</Benifit>
    <Benifit>Add the plan for just ${Math.round(props.application.pricing.protectionPlan)}/month.</Benifit>
    <ProtectionPlanTerms portalSlug={props.portalSlug}/>
  </div>
);

const Benifit = (props: React.PropsWithChildren<{}>) => (
  <div className='d-flex'>
    <div><FontAwesomeIcon icon={faCheck} className='mr-2'/> </div>
    <div>{props.children}</div>
  </div>

);
